<template>
  <div class="mainFrameContainer">
    <div class="rightBox">
      <div class="rightListBox">
        <div class="box_title">
          <p class="title">我能订货的公司</p>
        </div>
        <div class="rightLook">
          <div class="company" v-for="saleOrg in saleOrgList">
            <ul>
              <li>
                <a class="select" @click="goProduct(saleOrg.id,saleOrg.name)">
                  <div class="button">点击进入</div>
                  <p>公司简称：<span>{{saleOrg.simpleName === null?'无':saleOrg.simpleName}}</span></p>
                  <p v-if="currentUser.userType === 1">姓名：{{currentUser.person.name}}</p>
                  <p v-if="currentUser.userType === 2">姓名：{{currentUser.customer.name}}</p>
                  <p>公司全称：{{saleOrg.name}}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getOrgByCustomer, getOrgBySaleMan} from "../../../../api/system/org_sale";

export default {
  data () {
    return {
      currentUser:'',
      saleOrgList:[],
    };
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取用户销售组织列表
    this.getSaleOrgList()
  },
  methods: {
    getSaleOrgList(){
      if(this.currentUser.userType === 1){
        getOrgBySaleMan({'id':this.currentUser.id}).then(res => {
          this.saleOrgList = res.data
          //默认为第一个销售组织
          sessionStorage.setItem('saleOrgId',this.saleOrgList[0].id)
          sessionStorage.setItem('saleOrgName',this.saleOrgList[0].name)
        }).catch(()=>{
          // console.log('获取销售组织列表失败')
          this.$modal.msgError("获取您的销售组织列表失败，请重试")
          this.$router.push({ path: this.redirect || "/login" }).catch(()=>{});
        })
      } else if(this.currentUser.userType === 2){
        getOrgByCustomer({'id':this.currentUser.id}).then(res => {
          this.saleOrgList = res.data
          //默认为第一个销售组织
          sessionStorage.setItem('saleOrgId',this.saleOrgList[0].id)
          sessionStorage.setItem('saleOrgName',this.saleOrgList[0].name)
        }).catch(()=>{
          // console.log('获取销售组织列表失败')
          this.$modal.msgError("获取您的销售组织列表失败，请重试")
          this.$router.push({ path: this.redirect || "/login" }).catch(()=>{});
        })
      }
    },
    //跳转到物料列表页
    goProduct(saleOrgId,saleOrgName){
      sessionStorage.setItem('saleOrgId',saleOrgId)
      sessionStorage.setItem('saleOrgName',saleOrgName)
      this.$router.push({path: '/product/buyFeed'})
    },
  },
};
</script>

<style lang="less" scoped>
  div{
    display: block;
  }
  ul, li, a, p{
    padding: 0;
    margin: 0;
    list-style-type: none;
    text-decoration: none;
  }
  .mainFrameContainer {
    position: absolute;
    top: 20px;
    left: 10px;
    bottom: 0;
    right: 0;
    overflow: hidden;
    z-index: 4;
    overflow-y: auto;
  }
  .rightBox{
    width: auto;
  }
  .rightListBox{
    padding: 18px 30px 20px 20px;
  }
  .rightLook {
    margin-bottom: 10px;
    margin-top: 15px;
    width: 100%;
    color: #6a5c5c;
    font-size: 12px;
    display: block;
  }
  a{
    display: block;
    width: 365px;
    height: 176px;
    background: #FFFFFF;
    border:1px solid #E5E5E5;
    float:left;
    margin-right: 16px;
    margin-bottom: 16px;
  }
  a:hover{
    border-color: red;
  }
  p{
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin-bottom: 12px;
    padding-left: 30px;
    padding-right: 30px;
  }
  span{
    color: #ff1500;
  }
  .title {
    display: block;
    font-size: 24px;
    font-weight: bold;
    padding-left: 0;
  }
  .button{
    color: #FFFFFF;
    text-align: center;
    line-height: 30px;
    width: 100px;
    height: 30px;
    background: #BE1304;
    margin-bottom: 15px;
  }
</style>

